export default __webpack_public_path__ + "static/media/fad-pointer.cbe262c8.svg";